import { Expose } from "class-transformer";

export class CreateModelDto {
  @Expose()
  name: string;

  @Expose()
  manufacturerId: string;
}
